import React from "react";
import styles from "./AptechAimsCard.module.scss";
import { Icon } from "../../assets/Icons.tsx";

interface WorkforceItem {
  src: string;
  text: string;
  bold?: string;
}

interface AptechAimsCardProps {
  title: string;
  workforce: WorkforceItem[];
  contentPadding: Boolean;
  colNumber?: number;
  colNumberInSm?: number;
}

const AptechAimsCard: React.FC<AptechAimsCardProps> = ({
  title,
  workforce,
  contentPadding,
  colNumber = 3,
  colNumberInSm = 6,
}) => {
  return (
    <div className={styles.aimsCard}>
      <div className="row">
        <div className="col-12">
          <p className="para">
            <strong>{title}</strong>
          </p>
        </div>
      </div>

      <div className="row mt-2">
        {workforce.map((workitem, index) => (
          <div
            className={`col-${colNumberInSm} col-lg-${colNumber} col-md-6 col-sm-${colNumberInSm} mb-3`}
            key={index}
          >
            <Icon width="80px" height="80px" name={workitem.src} />
            <p className="heading3 mb-0 mt-3">
              <strong>{workitem.bold}</strong>
            </p>
            <p className={`para ${styles.aimTextStyle}`}>{workitem.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AptechAimsCard;
